<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-1">
      <h2 class="m-0 font-lato text-[16px] text-[#092E87]">Quote Total:</h2>
      <h3 v-if="quoteSummary.total_text != null" class="m-0 font-lato font-bold text-[40px] text-[#333333]">
        ${{ $helper.formatAmountMode(quoteSummary.total,1)}}.<span class="text-[25px]">{{
          $helper.formatAmountMode(quoteSummary.total,2) }}</span>
      </h3>
    </div>
    <div class="flex items-center gap-4">
      <button type="button" @click="viewQuoteClicked"
        class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#092E87] laptop:hover:text-[#fff] border-1 border-[#092E87] mobile:bg-[#092E87] laptop:bg-[#fff] hover:bg-[#092E87] transition duration-300">
        View Quote
        <span
          class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#092E87] relative">
          <!-- Default Image -->
          <img :src="require(`@/assets/images/buttons-icons/view-quote.png`)" alt="icon"
            class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />

          <!-- Hover Color Version -->
          <div
            class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
            :style="{
              WebkitMask: `url(${require(`@/assets/images/buttons-icons/view-quote.png`)}) no-repeat center / contain`,
              mask: `url(${require(`@/assets/images/buttons-icons/view-quote.png`)}) no-repeat center / contain`,
              backgroundColor: '#092E87'
            }"></div>
        </span>
      </button>

      <button type="button" @click="editQuoteClicked"
        class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#FE5000] hover:text-[#fff] border-1 border-[#FE5000] mobile:bg-[#FE5000] laptop:bg-[#fff] laptop:hover:bg-[#FE5000] transition duration-300">
        Edit Quote
        <span
          class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#FE5000] relative">
          <!-- Default Image -->
          <img :src="require(`@/assets/images/buttons-icons/edit-quote.png`)" alt="icon"
            class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />
          <!-- Hover Color Version -->
          <div
            class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
            :style="{
              WebkitMask: `url(${require(`@/assets/images/buttons-icons/edit-quote.png`)}) no-repeat center / contain`,
              mask: `url(${require(`@/assets/images/buttons-icons/edit-quote.png`)}) no-repeat center / contain`,
              backgroundColor: '#FE5000'
            }"></div>
        </span>
      </button>
    </div>

    <!-- Modal -->
    <div id="exampleModal" ref="modalSummary" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <QuoteModal :quote-summary="summary" @event="modal.hide()" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QuoteModal from "@/components/quote_modal/QuoteModal.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import { disableScroll } from "../../helpers/scrollHelper";
const toast = useToast();

export default {

  props: ['no_of_units'],
  components: {
    QuoteModal,
  },

  data() {
    return {
      summary: null,
    };
  },
  computed: {
    ...mapGetters([
      "storeQuoteData",
      "quoteDetail",
      "quoteSummary",
      "updateQuoteSummary",
    ]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    }
  },

  watch: {
    quoteSummary: function (data) {
      if (data != null) {
        this.summary = data;
        this.modal = new Modal(this.$refs.modalSummary);
        this.modal.show();
        disableScroll()
      }
    },

    updateQuoteSummary: function () {
      
      if ((this.$route.query.is_from_mobile ?? 0) == '1') {
        this.$router.push({ path: `/success`, query:{
          flow: "uq-update",
          is_from_mobile: this.$route.query.is_from_mobile
        } });
      } else {
        toast.success("Quote has been updated successfully.");
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }
      
    },
  },

  mounted() {
    this.clearState();

    var params = {
      manual_quote_id: this.quoteDetail.id,
    };
    if (this.isPartnerQuote) {
      this.getQuoteSummary({
        url: "/manual-quote/partner/summary",
        params: params
      });
    } else {
      this.getQuoteSummary({
        url: "/manual-quote/summary/calculate",
        params: params
      });
    }
    
  },

  methods: {
    ...mapActions([
      "getQuoteSummary",
      "setCommponent",
      "clearState",
    ]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
      window.location.reload()
    },

    viewQuoteClicked() {
      this.modal = new Modal(this.$refs.modalSummary);
      this.modal.show();
      disableScroll()
    },

    getPrice(ammount) {
      if (ammount != null) {
        ammount.replace("$", "");
      }
      return ammount;
    },
  },
};
</script>
